export const semanticShadows = {
  card: "0px 2px 8px 0px rgba(0, 0, 0, 0.02)",
  cardHover: "0px 4px 16px 4px rgba(0, 0, 0, 0.08)",
  modal: "0px 8px 40px 0px rgba(0, 0, 0, 0.1)",
  rightPanel: "0px 0px 40px 0px rgba(0, 0, 0, 0.1)",
  dropdown: "0px 4px 16px 0px rgba(0, 0, 0, 0.1)",
  tab: "0px 2px 4px 0px rgba(0, 0, 0, 0.04)",
};
